import Highway from '@dogstudio/highway'
import gsap from 'gsap'

import { classesInjection } from '../utils/transitions'

export class Fade extends Highway.Transition {
  in({ from, to, done }) {
    window.scrollTo(0, 0)
    classesInjection(to)

    from.remove()
    gsap.fromTo(
      to,
      { opacity: 0 },
      {
        opacity: 1,
        duration: 0.35,
        onComplete: done,
      },
    )
    return this
  }

  out({ from, done }) {
    gsap.fromTo(
      from,
      { opacity: 1 },
      {
        opacity: 0,
        duration: 0.35,
        onComplete: done,
      },
    )
    return this
  }
}
